<template>
    <div v-if="showEnergy">
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                <span id="banking__1">Energy</span>
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                <span id="banking__2">Energy - Term Details</span>
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">Rate Type : </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-select :items="rate_type_options" outlined dense attach v-model="energy_rate_type" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">Offer Price (per kWh) : </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-text-field outlined dense v-model="energy_offer_price_per_kwh" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">Term Length : </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-select :items="term_length" outlined dense attach v-model="energy_term_length" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">Cancel Fee : </v-col>
            <v-col :cols="1" class="text-left no-left no-bottom no-top">
                <v-checkbox label="Yes" v-model="energy_cancel_fee" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Cancel Fee Details:
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-textarea outlined dense name="input-7-1" v-model="energy_cancel_fee_details" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">Rate Type 2: </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-select :items="rate_type_options" outlined dense attach v-model="energy_rate_type2" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">Offer Price 2 (per kWh) : </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-text-field outlined dense v-model="energy_offer_price_per_kwh2" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">Term Length 2: </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-select :items="term_length" outlined dense attach v-model="energy_term_length2" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">Rate Type 3: </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-select :items="rate_type_options" outlined dense attach v-model="energy_rate_type3" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">Offer Price 3 (per kWh) : </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-text-field outlined dense v-model="energy_offer_price_per_kwh3" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">Term Length 3: </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-select :items="term_length" outlined dense attach v-model="energy_term_length3" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">Rate Type 4: </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-select :items="rate_type_options" outlined dense attach v-model="energy_rate_type4" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">Offer Price 4 (per kWh) : </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-text-field outlined dense v-model="energy_offer_price_per_kwh4" />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">Term Length 4: </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-select :items="term_length" outlined dense attach v-model="energy_term_length4" />
            </v-col>
        </v-row>

    </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
    name: 'Energy',
    data: () => ({
        items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
        //rate_type_options: [{text:'Select One',value:''},{text:'Fixed',value:1},{text:'Variable',value:2},{text:'Promotional',value:3}]
    }),
    props: [
        "showEnergy"
    ],
    computed: {
        ...mapGetters({
            sector: 'ProductData/getSector',
            category: 'ProductData/getCategory',
            rate_type_options: 'ProductData/getEnergyRateTypes',
            term_length: 'ProductData/getAllEnergyTermLength'
        }),
        energy_offer_price_per_kwh: {
            get: function () {
                return this.$store.getters['ProductData/getEnergyOfferPricePerKwh']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setEnergyOfferPricePerKwh', o)
            },
        },
        energy_offer_price_per_kwh2: {
            get: function () {
                return this.$store.getters['ProductData/getEnergyOfferPricePerKwh2']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setEnergyOfferPricePerKwh2', o)
            },
        },
        energy_offer_price_per_kwh3: {
            get: function () {
                return this.$store.getters['ProductData/getEnergyOfferPricePerKwh3']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setEnergyOfferPricePerKwh3', o)
            },
        },
        energy_offer_price_per_kwh4: {
            get: function () {
                return this.$store.getters['ProductData/getEnergyOfferPricePerKwh4']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setEnergyOfferPricePerKwh4', o)
            },
        },
        energy_term_length: {
            get: function () {
                return this.$store.getters['ProductData/getEnergyTermLength']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setEnergyTermLength', o)
            },
        },
        energy_term_length2: {
            get: function () {
                return this.$store.getters['ProductData/getEnergyTermLength2']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setEnergyTermLength2', o)
            },
        },
        energy_term_length3: {
            get: function () {
                return this.$store.getters['ProductData/getEnergyTermLength3']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setEnergyTermLength3', o)
            },
        },
        energy_term_length4: {
            get: function () {
                return this.$store.getters['ProductData/getEnergyTermLength4']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setEnergyTermLength4', o)
            },
        },
        energy_cancel_fee: {
            get: function () {
                return this.$store.getters['ProductData/getEnergyCancelFee']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setEnergyCancelFee', o)
            },
        },
        energy_cancel_fee_details: {
            get: function () {
                return this.$store.getters['ProductData/getEnergyCancelFeeDetails']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setEnergyCancelFeeDetails', o)
            },
        },
        energy_rate_type: {
            get: function () {
                return this.$store.getters['ProductData/getEnergyRateType']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setEnergyRateType', o)
            },
        },
        energy_rate_type2: {
            get: function () {
                return this.$store.getters['ProductData/getEnergyRateType2']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setEnergyRateType2', o)
            },
        },
        energy_rate_type3: {
            get: function () {
                return this.$store.getters['ProductData/getEnergyRateType3']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setEnergyRateType3', o)
            },
        },
        energy_rate_type4: {
            get: function () {
                return this.$store.getters['ProductData/getEnergyRateType4']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/setEnergyRateType4', o)
            },
        },
    },
}
</script>

<style lang="sass" scoped>
@import './../../assets/sass/product/banking'
</style>